import React from 'react';
import { PartyPopperIcon, CheckIcon, CakeIcon, UsersIcon, GiftIcon, StarIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const partyFeatures = ['Dedicated party host for your group', 'Private party rooms', 'Food & drinks packages', 'Choice of attractions', 'Party supplies & decorations', 'Early bird booking discounts'];
export function BirthdayParties() {
  return <section id="parties" className="py-16 md:py-24 px-4 bg-gradient-to-br from-white via-pulse-yellow/5 to-pulse-orange/5" data-id="element-37">
      <div className="max-w-7xl mx-auto" data-id="element-38">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-39">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-40">
            <div className="inline-flex items-center gap-2 bg-pulse-orange/10 text-pulse-orange px-4 py-2 rounded-full mb-6" data-id="element-41">
              <PartyPopperIcon className="h-5 w-5" data-id="element-42" />
              <span className="font-semibold text-sm uppercase tracking-wide" data-id="element-43">
                Coming Soon
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-pulse-navy uppercase tracking-tight" data-id="element-44">
              Plan Your Celebration Early!
            </h2>

            <p className="mt-6 text-lg text-gray-600 leading-relaxed" data-id="element-45">
              Be among the first to book a birthday party at Pulse! Our
              all-inclusive packages will make planning a breeze. Sign up now to
              get early access to party bookings.
            </p>

            <ul className="mt-8 space-y-4" data-id="element-46">
              {partyFeatures.map((feature, index) => <motion.li key={feature} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-center gap-3" data-id="element-47">
                  <div className="w-6 h-6 rounded-full bg-pulse-orange/20 flex items-center justify-center flex-shrink-0" data-id="element-48">
                    <CheckIcon className="h-4 w-4 text-pulse-orange" data-id="element-49" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-50">{feature}</span>
                </motion.li>)}
            </ul>

            <div className="mt-10 flex flex-col sm:flex-row gap-4" data-id="element-51">
              <a href="#signup" className="inline-flex items-center justify-center gap-2 bg-pulse-orange hover:bg-orange-500 text-white px-8 py-4 rounded-full font-bold uppercase tracking-wide transition-all hover:scale-105" data-id="element-52">
                Join the Party Waitlist
              </a>
              <a href="#attractions" className="inline-flex items-center justify-center gap-2 border-2 border-pulse-navy text-pulse-navy hover:bg-pulse-navy hover:text-white px-8 py-4 rounded-full font-bold uppercase tracking-wide transition-all" data-id="element-53">
                Learn More
              </a>
            </div>
          </motion.div>

          {/* Decorative Area */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-54">
            <div className="aspect-square max-w-md mx-auto bg-gradient-to-br from-pulse-orange/20 via-pulse-yellow/20 to-pulse-blue/20 rounded-3xl p-8 relative overflow-hidden" data-id="element-55">
              {/* Floating Icons */}
              <motion.div animate={{
              y: [0, -15, 0],
              rotate: [0, 10, 0]
            }} transition={{
              duration: 4,
              repeat: Infinity
            }} className="absolute top-12 left-12 w-20 h-20 bg-white rounded-2xl shadow-lg flex items-center justify-center" data-id="element-56">
                <CakeIcon className="h-10 w-10 text-pulse-orange" data-id="element-57" />
              </motion.div>

              <motion.div animate={{
              y: [0, 15, 0],
              rotate: [0, -10, 0]
            }} transition={{
              duration: 5,
              repeat: Infinity,
              delay: 0.5
            }} className="absolute top-24 right-12 w-16 h-16 bg-white rounded-2xl shadow-lg flex items-center justify-center" data-id="element-58">
                <GiftIcon className="h-8 w-8 text-pulse-yellow" data-id="element-59" />
              </motion.div>

              <motion.div animate={{
              y: [0, -10, 0]
            }} transition={{
              duration: 3.5,
              repeat: Infinity,
              delay: 1
            }} className="absolute bottom-24 left-16 w-16 h-16 bg-white rounded-2xl shadow-lg flex items-center justify-center" data-id="element-60">
                <StarIcon className="h-8 w-8 text-pulse-blue" data-id="element-61" />
              </motion.div>

              <motion.div animate={{
              y: [0, 12, 0],
              rotate: [0, -5, 0]
            }} transition={{
              duration: 4.5,
              repeat: Infinity,
              delay: 0.8
            }} className="absolute bottom-16 right-16 w-20 h-20 bg-white rounded-2xl shadow-lg flex items-center justify-center" data-id="element-62">
                <UsersIcon className="h-10 w-10 text-pulse-navy" data-id="element-63" />
              </motion.div>

              {/* Center Element */}
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-64">
                <motion.div animate={{
                scale: [1, 1.05, 1]
              }} transition={{
                duration: 3,
                repeat: Infinity
              }} className="w-32 h-32 bg-white rounded-full shadow-xl flex items-center justify-center" data-id="element-65">
                  <PartyPopperIcon className="h-16 w-16 text-pulse-orange" data-id="element-66" />
                </motion.div>
              </div>

              {/* Confetti dots */}
              <div className="absolute top-8 right-1/3 w-3 h-3 bg-pulse-blue rounded-full" data-id="element-67" />
              <div className="absolute top-1/3 left-8 w-2 h-2 bg-pulse-yellow rounded-full" data-id="element-68" />
              <div className="absolute bottom-12 right-1/4 w-2 h-2 bg-pulse-orange rounded-full" data-id="element-69" />
              <div className="absolute bottom-1/3 left-1/4 w-3 h-3 bg-pulse-blue rounded-full" data-id="element-70" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}